import React from 'react';
import { FiMapPin } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import { getSiteConfig } from '../../utils/siteConfig';

const MapIcon = FiMapPin as React.ComponentType<{ className?: string }>;

const AboutLocations: React.FC = () => {
  const { t } = useTranslation();
  const siteConfig = getSiteConfig();

  return (
    <section className="py-24 bg-[#F7F8FA]">
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-3xl font-bold text-[#0F172A] tracking-tight text-center mb-12">
          {t('aboutPageSection.locations.title')}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {siteConfig.offices.map((office) => (
            <article
              key={`${siteConfig.key}-${office.city}`}
              className="bg-white border border-[#E2E8F0] rounded-xl p-6 hover:shadow-md hover:border-teal-200 transition-all"
            >
              <span className="w-10 h-10 rounded-lg bg-teal-50 flex items-center justify-center mb-4">
                <MapIcon className="w-5 h-5 text-teal-600" />
              </span>
              <h3 className="text-lg font-bold text-[#0F172A]">{office.city}</h3>
              <p className="text-xs text-teal-600 font-semibold uppercase tracking-wide mt-1">{office.type}</p>
              <p className="text-[#64748B] text-sm mt-3">{office.address}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutLocations;
